import { useState } from 'react';

const GeneralDisclaimerStep = ({ onSubmit, onBack, context }) => {
  const [checked, setChecked] = useState(false);
  const content = context?.ackData?.general_acknowledgement || '';

  return (
    <div className="space-y-4 w-full">
      <div className="max-h-[240px] overflow-y-auto rounded border border-gray-700 p-3 text-sm text-gray-400 whitespace-pre-wrap bg-black/40 no-scrollbar">
        {content || <span className="italic text-gray-500">No disclaimer text available.</span>}
      </div>
      <label className="flex items-start gap-3 text-sm text-gray-300 cursor-pointer">
        <input
          type="checkbox"
          checked={checked}
          onChange={() => setChecked(v => !v)}
          className="mt-0.5 w-4 h-4 shrink-0"
        />
        <span>I confirm that I have read, understand, and agree to the above disclaimer.</span>
      </label>
      <button
        onClick={onSubmit}
        disabled={!checked}
        className="w-full bg-[#7B7B7B] hover:bg-gray-500 text-white py-3 rounded-lg transition disabled:opacity-50 disabled:cursor-not-allowed text-sm"
      >
        Continue
      </button>
      {/* <button onClick={onBack} className="w-full border border-gray-700 hover:border-gray-500 text-white py-3 rounded-lg transition text-sm">Back</button> */}
    </div>
  );
};

export default GeneralDisclaimerStep;
